export default "__VITE_ASSET__BbyvdUw9__"